__turbopack_context__.v({
  "buttonsWrapper": "f7dpvG_buttonsWrapper",
  "description": "f7dpvG_description",
  "highlight": "f7dpvG_highlight",
  "sectionTitle": "f7dpvG_sectionTitle",
});
